import { Icon } from './Icon';

export function AgeGate({ onEnter }: { onEnter: () => void }) {
  return (
    <main className="age-gate">
      <div className="age-gate__backdrop" />
      <section className="age-card" aria-labelledby="age-title">
        <div className="eyebrow">CORRUPTED SAVE FILE // 18+</div>
        <h1 id="age-title">
          MARKET
          <br />
          <span>MAYHEM</span>
        </h1>
        <p>
          Profanity. Adult satire. Fake monsters making terrible market calls. No financial
          advice, no promises, no babysitter.
        </p>
        <div className="warning-strip">
          <Icon name="shield" size={18} />
          FREE TO PLAY · NO DEPOSITS · NO WAGERS
        </div>
        <button className="primary-button primary-button--wide" onClick={onEnter}>
          I&apos;M 18+. OPEN THE DAMN GATE
          <Icon name="chevron" size={20} />
        </button>
        <small>
          FUKÉMON is independent parody chaos and is not affiliated with Robinhood or any
          company represented by market data.
        </small>
      </section>
    </main>
  );
}

